import moment from 'moment';
import React from 'react';
import { Modal } from 'reactstrap';
import offer_popup from '../../../images/new-design/offer-popup.png';
import './index.css';
import Countdown from '../../Common/Header/Timer';


const OfferModal = (props) => {
    const { offerShowModal, toggleOfferModal, settingsData, getSlug, offerSlugs, offerOn, isPackageOffer, isTrailOffer, packageDiscount, trailDiscount, packageValidDate, trailValidDate } = props;
    return <Modal isOpen={offerShowModal} centered={true} toggle={(e) => toggleOfferModal()} backdrop={true} className='offer-container'>
        <div className="offer-model">
            <div className="offer-top">
                <div className="offer-top-less">
                {settingsData?.offertitle != "" && <h6>{settingsData?.offertitle}</h6>}
                    <p>Get</p>
                    <h3>{isPackageOffer ? `${packageDiscount}%` : isTrailOffer ? `${trailDiscount}s` : ''}</h3>
                    <p> {isPackageOffer ? `Offer On Selected Packages` : isTrailOffer ? settingsData?.trialExpirytitle || `Free Subscription` : ''} </p>
                </div>
                <div className="offer-count" style={{marginBottom:'6px'}}>
                <p style={{margin:'5px'}}>Offer Ends in</p>
                <Countdown expiryTimestamp={settingsData?.offerExpiry}/>
                </div>
                <div className="offer-valid">
                    <p>VALID TILL</p>
                    <span className="valid-date">{moment(packageValidDate ? packageValidDate : settingsData?.offerExpiry ? settingsData.offerExpiry :trailValidDate).format('DD MMM YYYY')}
                    </span>
                </div>
            </div>
            <div className="offer-section">
                <div className="offer-left">
                    <img src={offer_popup} />
                </div>
                <div className="offer-right">
                    {isPackageOffer ? offerSlugs && offerSlugs.length > 0 && offerSlugs.map((item, i) => {
                        return <div className="offer-details" key={i}>
                            <span> {packageDiscount}% Off</span>
                            <p>{item.name}</p>
                            <a href={`/subscription-detail/${item.slug}`}>View Package <i class="fa fa-angle-right" aria-hidden="true"></i></a>
                        </div>
                    }) : isTrailOffer ?
                        <div className="offer-details sub">
                            <span>Enjoy {trailDiscount} of Enhanced Access</span>
                            <p>Stay Compliant with Effortless Policy & Document Updates</p>
                            <p style={{marginTop:'5px',marginBottom:'5px'}}>Efficient. Reliable. Hassle-Free.</p>
                            {/* <p>Policy Updates And Documents Management System</p> */}
                            <a href="/policies-procedures">Available Now <i class="fa fa-angle-right" aria-hidden="true"></i></a>
                        </div>
                        : null}
                </div>
            </div>
            <button onClick={() => toggleOfferModal()}> No Thanks!</button>
        </div>
    </Modal>
};

export default OfferModal;
